<template>
    <form class="hidden md:flex w-full justify-center bg-blue-800 rounded" method="get" action="https://www.torbay.gov.uk/search">
        <label for="term" class="sr-only text-white">Website Search</label>
        <input id="term" class="px-2 py-1 border-0 flex-grow max-w-lg text-white bg-blue-800 rounded placeholder-blue-100 focus:bg-white focus:text-gray-900 focus:placeholder-gray-500 focus:outline-none focus:shadow-outline hover:shadow-outline" placeholder="Search our website" type="search" name="term" value="" />
        <button class="flex items-center border-0 bg-transparent text-blue-100 rounded px-2 py-1 focus:outline-none focus:shadow-outline hover:shadow-outline" type="submit" value="Search">
            <svg class="w-8 h-8" aria-hidden="true" viewBox="0 0 24 24">
                <title>Search</title>
                <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
            <span class="sr-only">Search</span>
        </button>
    </form>
</template>

<script>
    export default {
        name: "Search"
    };
</script>
